import {columnGoalSetting, inputColumnGoalSetting, inputManualColumnGoalSetting, radioColumnGoalSetting} from './types';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';

export const isInput = (column: columnGoalSetting): boolean =>
    !!(column as inputColumnGoalSetting).isInput;

export const showingInput = (column: columnGoalSetting): boolean =>
    !!(column as inputManualColumnGoalSetting).isInput || !!(column as radioColumnGoalSetting).isRadio;

export const indexFirstInput = (columns: GoalSettingColumns): number =>
    columns.iterator
        .map(showingInput)
        .indexOf(true);

export const indexLastInput = (columns: GoalSettingColumns): number =>
    columns.iterator
        .slice(indexFirstInput(columns))
        .map(showingInput)
        .indexOf(false) + indexFirstInput(columns) - 1;

export const styleCellFactory = (columns: GoalSettingColumns): (col: columnGoalSetting, i: number) => any[] => {
  const firstIndexInput = indexFirstInput(columns);
  const lastIndexInput = indexLastInput(columns);

  return (col, i) => [
    {firstColumn: i === 0},
    {active: showingInput(col)},
    {firstInput: i === firstIndexInput},
    {lastInput: i === lastIndexInput}
  ];
};
